export default "__VITE_ASSET__Di_3aG9k__"